import { createAction } from 'redux-actions';
import {
  createAsyncActions,
  runAsyncWorkflow
} from '../lib/reduxHelpers';

import { ReadingList } from '../api';

export const [
  fetchReadingListDetails,
  receiveReadingListDetails,
  fetchReadingListDetailsError
] = createAsyncActions(
  'READING_LIST_DETAILS',
  slug => ({ slug }),
  ({ok, data}) => ({ok, data})
);

export const fetchReadingListDetailsWorkflow = slug => {
  const fetchPromise = ReadingList.fetchDetails(slug);
  
  return runAsyncWorkflow({
      fetch: fetchReadingListDetails,
      receive: receiveReadingListDetails,
      error: fetchReadingListDetailsError
    },
    fetchPromise,
    { slug },
    true,
    (dispatchFn, error) => {},
    true
  );
};

export const [
  postReadingListLike,
  receiveReadingListLike,
  postReadingListLikeError
] = createAsyncActions(
  'READING_LIST_LIKE',
  slug => ({ slug }),
  ({ ok, data }) => ({ readingList: data }),
  'POST'
);

export const postReadingListLikeWorkflow = slug => {
  const postPromise = ReadingList.postLike(slug);

  return runAsyncWorkflow(
    {
      fetch: postReadingListLike,
      receive: receiveReadingListLike,
      error: postReadingListLikeError
    },
    postPromise,
    { slug }
  );
};

export const [
  updateReadingList,
  receiveUpdateReadingList,
  updateReadingListError
] = createAsyncActions(
  'UPDATE_READING_LIST',
  readingList => ({ readingList }),
  ({ ok, data }) => ({ readingList: data }),
  'PUT'
);

export const updateReadingListWorkflow = readingList => {
  const updateReadingListPromise = ReadingList.update(readingList);

  return runAsyncWorkflow(
    {
      fetch: updateReadingList,
      receive: receiveUpdateReadingList,
      error: updateReadingListError
    },
    updateReadingListPromise,
    { readingList }
  );
};


export const [
  createReadingList,
  receiveCreateReadingList,
  createReadingListError
] = createAsyncActions(
  'CREATE_READING_LIST',
  (title, description, books) => ({ title, description, books }),
  ({ data }) => ({ readingList: data })
);

export const createReadingListWorkflow = (name, description, books) => {
  const createReadingListPromise = ReadingList.create(name, description, books);

  return runAsyncWorkflow(
    {
      fetch: createReadingList,
      receive: receiveCreateReadingList,
      error: createReadingListError
    },
    createReadingListPromise
  );
};

export const [
  fetchListDownloadLimit,
  receiveListDownloadLimit,
  fetchListDownloadLimitError
] = createAsyncActions(
  'LIST_DOWNLOAD_LIMIT',
  slug => ({ slug })
);

export const fetchListDownloadLimitWorkflow = slug => {
  const fetchPromise = ReadingList.fetchDetails(slug);

  return runAsyncWorkflow({
    fetch: fetchListDownloadLimit,
    receive: receiveListDownloadLimit,
    error : fetchListDownloadLimitError
  }, fetchPromise);
};

export const openListQuickView = createAction(
  'sw/OPEN_LIST_QUICK_VIEW',
  list => ({ list })
);
export const closeListQuickView = createAction('sw/CLOSE_LIST_QUICK_VIEW');

export const [
  setStoryStatus,
  receiveSetStoryStatus,
  setStoryStatusError
] = createAsyncActions(
  'SET_STORY_STATUS',
  ({ storyId, registrationId, status }) => ({ storyId, registrationId, status }),
  ({ data }) => ({ data: data })
);

export const campaignSetStoryStatus = (storyId, registrationId, status, campaignType) => {
  const fetchPromise = ReadingList.setStoryStatus(storyId, registrationId, status, campaignType);
  
  return runAsyncWorkflow({
    fetch: setStoryStatus,
    receive: receiveSetStoryStatus,
    error: setStoryStatusError
  }, fetchPromise);
};

export const [
  fetchStoryStatus,
  receiveStoryStatus,
  fetchStoryStatusError
] = createAsyncActions(
  'CHECK_STORY_STATUS',
  ({ registrationId }) => ({ registrationId }),
  ({ data }) => ({ status: data.storiesStatus })
);

export const campaignCheckStoryStatus = (registrationId, campaignType) => {
  const fetchPromise = ReadingList.checkStoryStatus( registrationId, campaignType );
  
  return runAsyncWorkflow({
    fetch: fetchStoryStatus,
    receive: receiveStoryStatus,
    error: fetchStoryStatusError
  }, fetchPromise);
};




// WEBPACK FOOTER //
// ./src/redux/readingListsActions.js